import { createContext, useContext } from 'react';

export const MDContext = createContext();

const useMDContext = () => useContext(MDContext);

export default useMDContext;
